import React from 'react';
import { clsx } from 'clsx';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  showSubtext?: boolean;
  variant?: 'default' | 'light' | 'dark';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({
  size = 'md',
  showText = true,
  showSubtext = true,
  variant = 'default',
  className
}) => {
  // Configuración de tamaños
  const sizeConfig = {
    sm: {
      container: 'h-8 w-8',
      text: 'text-lg',
      title: 'text-lg',
      subtitle: 'text-xs'
    },
    md: {
      container: 'h-12 w-12',
      text: 'text-xl',
      title: 'text-xl',
      subtitle: 'text-sm'
    },
    lg: {
      container: 'h-16 w-16',
      text: 'text-2xl',
      title: 'text-2xl',
      subtitle: 'text-sm'
    },
    xl: {
      container: 'h-20 w-20',
      text: 'text-3xl',
      title: 'text-3xl',
      subtitle: 'text-base'
    }
  };

  // Configuración de variantes
  const variantConfig = {
    default: {
      background: 'bg-gradient-to-br from-mava-500 to-mava-700',
      letter: 'text-white',
      title: 'text-gray-900',
      subtitle: 'text-gray-600'
    },
    light: {
      background: 'bg-gradient-to-br from-white to-gray-100 border border-gray-200',
      letter: 'text-mava-600',
      title: 'text-white',
      subtitle: 'text-gray-200'
    },
    dark: {
      background: 'bg-gradient-to-br from-gray-800 to-gray-900',
      letter: 'text-mava-400',
      title: 'text-white',
      subtitle: 'text-gray-300'
    }
  };

  const config = sizeConfig[size];
  const colors = variantConfig[variant];

  return (
    <div className={clsx('flex items-center space-x-3', className)}>
      {/* Logo Icon */}
      <div className={clsx(
        'rounded-2xl flex items-center justify-center shadow-lg',
        config.container,
        colors.background
      )}>
        <span className={clsx(
          'font-bold',
          config.text,
          colors.letter
        )}>
          M
        </span>
      </div>

      {/* Text Content */}
      {showText && (
        <div className="flex flex-col">
          <h1 className={clsx(
            'font-bold leading-tight',
            config.title,
            colors.title
          )}>
            MAVA
          </h1>
          {showSubtext && (
            <p className={clsx(
              'leading-tight',
              config.subtitle,
              colors.subtitle
            )}>
              Sistema de Reportes de Maquinaria
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default Logo;
